import React from 'react';
import { Box, Paragraph, Text } from 'bumbag';

import { getSafeCallbackUrl } from 'legacy/utils/getSafeCallbackUrl';

import T from '../common/ReactTMinus';
type Props = {
  redirectUrl: string;
};
export default class ReactCountdown extends React.PureComponent<Props> {
  handleCompleteCountdown = () => {
    const safeRedirectUrl = getSafeCallbackUrl(this.props.redirectUrl);

    if (safeRedirectUrl) {
      window.location.href = safeRedirectUrl;
    }
  };
  render = () => {
    const safeRedirectUrl = getSafeCallbackUrl(this.props.redirectUrl);

    if (!safeRedirectUrl) {
      return null;
    }

    return (
      <Box {...this.props}>
        <T minus={5} onComplete={this.handleCompleteCountdown}>
          {({ secondsLeft }) => (
            <Paragraph>
              Redirecting back to your service provider in{' '}
              <Text fontWeight="semibold">{secondsLeft === 0 ? 'Redirecting' : secondsLeft}</Text>...
            </Paragraph>
          )}
        </T>
      </Box>
    );
  };
}
